import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';

const COLORES_DISPONIBLES = [
  { nombre: 'Rojo', hex: '#EF4444' },
  { nombre: 'Azul', hex: '#3B82F6' },
  { nombre: 'Negro', hex: '#000000' },
  { nombre: 'Blanco', hex: '#FFFFFF' },
  { nombre: 'Gris', hex: '#6B7280' },
  { nombre: 'Verde', hex: '#10B981' },
  { nombre: 'Amarillo', hex: '#F59E0B' },
  { nombre: 'Naranja', hex: '#F97316' },
  { nombre: 'Morado', hex: '#8B5CF6' },
  { nombre: 'Rosa', hex: '#EC4899' }
];

export default function ColorSelector({ selected = [], onChange, minSelection = 3, maxSelection = 5 }) {
  const handleColorClick = (color) => {
    if (selected.includes(color.nombre)) {
      onChange(selected.filter(c => c !== color.nombre));
    } else if (selected.length < maxSelection) {
      onChange([...selected, color.nombre]);
    }
  };

  return (
    <div className="space-y-4">
      <p className="text-[#666666] text-sm">
        Selecciona entre {minSelection} y {maxSelection} colores de tu preferencia ({selected.length}/{maxSelection})
      </p>
      <div className="grid grid-cols-5 gap-4">
        {COLORES_DISPONIBLES.map((color) => {
          const isSelected = selected.includes(color.nombre);
          const selectionNumber = selected.indexOf(color.nombre) + 1;
          return (
            <motion.button
              key={color.nombre}
              type="button"
              onClick={() => handleColorClick(color)}
              className="relative aspect-square rounded-full border-2 transition-all duration-300"
              style={{
                backgroundColor: color.hex,
                borderColor: isSelected ? '#F5A623' : 'rgba(255, 255, 255, 0.2)'
              }}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              data-testid={`color-option-${color.nombre.toLowerCase()}`}
            >
              {isSelected && (
                <div className="absolute inset-0 flex items-center justify-center">
                  <div 
                    className="w-12 h-12 rounded-full flex items-center justify-center font-black text-2xl border-4"
                    style={{ 
                      backgroundColor: color.hex === '#000000' || color.hex === '#FFFFFF' ? '#F5A623' : '#000000',
                      color: color.hex === '#000000' || color.hex === '#FFFFFF' ? '#000000' : '#FFFFFF',
                      borderColor: '#F5A623'
                    }}
                  >
                    {selectionNumber}
                  </div>
                </div>
              )}
              <span className="sr-only">{color.nombre}</span>
            </motion.button>
          );
        })}
      </div>
    </div>
  );
}